// extracted by mini-css-extract-plugin
export default {"imgContainer":"styles_imgContainer__cQBkk","image":"styles_image__aWj9H"};